var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGluten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}.cls-2{stroke:#d00000;stroke-miterlimit:10;stroke-width:10px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.82,186.2s41.59-5.94,45.31,43.09C149.13,229.29,109.76,242.66,103.82,186.2Z",
    transform: "translate(-30 -30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.82,145.84s41.59-5.94,45.31,43.09C149.13,188.93,109.76,202.3,103.82,145.84Z",
    transform: "translate(-30 -30)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.82,107.38s41.59-5.94,45.31,43.08C149.13,150.46,109.76,163.84,103.82,107.38Z",
    transform: "translate(-30 -30)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.18,186.06s-41.59-5.94-45.31,43.09C150.87,229.15,190.24,242.52,196.18,186.06Z",
    transform: "translate(-30 -30)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.18,145.7s-41.59-5.94-45.31,43.08C150.87,188.78,190.24,202.16,196.18,145.7Z",
    transform: "translate(-30 -30)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.18,107.24s-41.59-5.95-45.31,43.08C150.87,150.32,190.24,163.69,196.18,107.24Z",
    transform: "translate(-30 -30)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,69.33s-33,26.07,0,62.53C150,131.86,186.84,112.52,150,69.33Z",
    transform: "translate(-30 -30)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265,150A115,115,0,1,1,150,35,115,115,0,0,1,265,150Z",
    transform: "translate(-30 -30)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluten);
export default __webpack_public_path__ + "static/media/gluten.d55e6dd2f02a0dced3969643c9291422.svg";
export { ForwardRef as ReactComponent };